import Cookies from 'js-cookie'
import systemService from '../../services/system/SystemService'

const moedaSistema = Cookies.get('moedaSistema') ?? 0
const filialCodigo = Cookies.get('filialCodigo') ?? null

export const systemModule = {
  namespaced: true,
  state: {
    systemInfo: null,
    moedaSistema: moedaSistema,
    filialCodigo: filialCodigo,
  },
  mutations: {
    SET_SYSTEM_INFO(state, payload) {
      state.systemInfo = payload
    },
    SET_MOEDA_SISTEMA(state, payload) {
      state.moedaSistema = payload
      Cookies.set('moedaSistema', payload, { expires: 365 })
    },
    SET_FILIAL_CODIGO(state, payload) {
      state.filialCodigo = payload
      Cookies.set('filialCodigo', payload, { expires: 365 })
    },
  },
  actions: {
    setSystemInfo({ commit }, payload) {
      commit('SET_SYSTEM_INFO', payload)
    },
    setMoedaSistema({ commit }, payload) {
      commit('SET_MOEDA_SISTEMA', payload)
    },
    setFilialCodigo({ commit }, payload) {
      commit('SET_FILIAL_CODIGO', payload)
    },
    async getSystemProps({}) {
      return await systemService.getSystemProps()
    },
    async getFiliais({}) {
      return await systemService.getFiliais()
    },
  },
  getters: {
    systemInfo: (state) => {
      return state.systemInfo
    },
    moedaSistema: (state) => {
      return state.moedaSistema
    },
    filialCodigo: (state) => {
      return state.filialCodigo
    },
    availableCoins: (state) => {
      if (!state.systemInfo) return []
      const coins = [
        state.systemInfo?.CIFRAO0,
        state.systemInfo?.CIFRAO1,
        state.systemInfo?.CIFRAO2,
      ]
      return coins
    },
  },
}
